import 'babel-polyfill'

import Vue from 'vue'

if(document.getElementById("popup_COMPETITION_SUPPORT_app")) {
    var app = new Vue({
        delimiters: ['[[', ']]'],
        el: '#popup_COMPETITION_SUPPORT_app',
        data: {
            showRawData: false,
        },
        methods: {
            toggleRawData: function() {
                this.showRawData = !this.showRawData;
            }
        }
    })
}